module.exports = __webpack_public_path__ + "img/borderBracketsWhite.86e80de1.svg";